// extracted by mini-css-extract-plugin
export default {"wrapper":"DiscountBlock_wrapper__PRl1O","discountTime":"DiscountBlock_discountTime__HsZ-I"};